import commonMapping from "@/mapping/common";

const fitleringModeList = [
  {
    config: "secured",
    value: "Secured",
    label: "adva_wansetup_nat_secured",
    id: "nat_filtering_secured",
  },
  {
    config: "open",
    value: "Open",
    label: "adva_wansetup_nat_open",
    id: "nat_filtering_open",
  },
];
const ipsec_enable_list = [
  {
    config: "1",
    value: "1",
    label: "r_enable",
    id: "enable_ipsec_passthrough1",
  },
  {
    config: "0",
    value: "0",
    label: "r_disable",
    id: "enable_ipsec_passthrough0",
  },
];
const pptp_enable_list = [
  {
    config: "1",
    value: "1",
    label: "r_enable",
    id: "enable_pptp_passthrough1",
  },
  {
    config: "0",
    value: "0",
    label: "r_disable",
    id: "enable_pptp_passthrough0",
  },
];
const l2tp_enable_list = [
  {
    config: "1",
    value: "1",
    label: "r_enable",
    id: "enable_l2tp_passthrough1",
  },
  {
    config: "0",
    value: "0",
    label: "r_disable",
    id: "enable_l2tp_passthrough0",
  },
];

const igmp_version_list = [
  { value: "0", config: "0", label: "auto_mark" },
  { value: "2",  config: "2", label: "IGMPv3" },
  { value: "1",  config: "1", label: "IGMPv2" },
];

export const wan = {
  dos_protect_disable: commonMapping.intToBoolean,
  dmz_enable: commonMapping.intToBoolean,
  respond_ping_enable: commonMapping.intToBoolean,
  filtering_mode: fitleringModeList,
  igmp_disable: commonMapping.intToBoolean,
  bt_enable: commonMapping.intToBoolean,
  sipalg_disable: commonMapping.intToBoolean,
  ipsec_enable: ipsec_enable_list,
  pptp_enable: pptp_enable_list,
  l2tp_enable: l2tp_enable_list,
  igmp_version: igmp_version_list,
};

export default wan;
